var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	2611: () => (loadSingletonVersionCheckFallback("default", "@angular/core", [1,16,1,1], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(1699))))))),
	3984: () => (loadSingletonVersionCheckFallback("default", "@angular/common/http", [1,16,1,1], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(4860))))))),
	8592: () => (loadSingletonVersionCheckFallback("default", "apollo-angular", [1,5,0,0], () => (__webpack_require__.e("node_modules_apollo-angular_fesm2022_ngApollo_mjs-_6ad91").then(() => (() => (__webpack_require__(1378))))))),
	3510: () => (loadSingletonVersionCheckFallback("default", "@angular/router", [1,16,1,1], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a221").then(() => (() => (__webpack_require__(7947))))))),
	1064: () => (loadSingletonFallback("default", "core", () => (__webpack_require__.e("dist_core_fesm2022_core_mjs-_5cc90").then(() => (() => (__webpack_require__(4991))))))),
	8103: () => (loadSingletonVersionCheckFallback("default", "rxjs/operators", [1,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(4117))))))),
	4187: () => (loadSingletonVersionCheckFallback("default", "@angular/common", [1,16,1,1], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(6575))))))),
	3821: () => (loadSingletonVersionCheckFallback("default", "@ng-bootstrap/ng-bootstrap", [1,15,0,1], () => (__webpack_require__.e("node_modules_ng-bootstrap_ng-bootstrap_fesm2022_ng-bootstrap_mjs-_1d631").then(() => (() => (__webpack_require__(3396))))))),
	1320: () => (loadSingletonFallback("default", "common", () => (__webpack_require__.e("dist_common_fesm2022_common_mjs-_8d251").then(() => (() => (__webpack_require__(4698))))))),
	7109: () => (loadSingletonVersionCheckFallback("default", "angular-svg-icon", [1,16,0,0], () => (__webpack_require__.e("node_modules_angular-svg-icon_fesm2022_angular-svg-icon_mjs-_47e30").then(() => (() => (__webpack_require__(1291))))))),
	5943: () => (loadSingletonVersionCheckFallback("default", "graphql", [1,16,7,1], () => (__webpack_require__.e("node_modules_graphql_index_mjs").then(() => (() => (__webpack_require__(2919))))))),
	8303: () => (loadSingletonVersionCheckFallback("default", "rxjs", [1,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(2153))))))),
	3656: () => (loadSingletonVersionCheckFallback("default", "@angular/animations", [1,16,1,1], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_animations_mjs").then(() => (() => (__webpack_require__(2501))))))),
	2496: () => (loadSingletonVersionCheckFallback("default", "@angular/forms", [1,16,1,1], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1").then(() => (() => (__webpack_require__(8849))))))),
	9298: () => (loadSingletonVersionCheckFallback("default", "lodash-es", [1,4,17,20], () => (__webpack_require__.e("node_modules_lodash-es_lodash_js-_ece71").then(() => (() => (__webpack_require__(3076))))))),
	5248: () => (loadSingletonVersionCheckFallback("default", "luxon", [4,3,3,0], () => (__webpack_require__.e("node_modules_luxon_src_luxon_js").then(() => (() => (__webpack_require__(1268))))))),
	9002: () => (loadSingletonVersionCheckFallback("default", "@swimlane/ngx-charts", [1,20,3,0], () => (__webpack_require__.e("node_modules_swimlane_ngx-charts_fesm2020_swimlane-ngx-charts_mjs-_7c261").then(() => (() => (__webpack_require__(5314))))))),
	6478: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/observers", [1,16,1,1], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_observers_mjs-_b1b11").then(() => (() => (__webpack_require__(6787))))))),
	4462: () => (loadSingletonVersionCheckFallback("default", "ngx-chips", [1,3,0,0], () => (__webpack_require__.e("node_modules_ngx-chips_fesm2020_ngx-chips_mjs-_65d51").then(() => (() => (__webpack_require__(6444))))))),
	3080: () => (loadSingletonVersionCheckFallback("default", "ng-animate", [1,2,0,1], () => (__webpack_require__.e("node_modules_ng-animate_fesm2020_ng-animate_mjs-_e1c31").then(() => (() => (__webpack_require__(8063))))))),
	4463: () => (loadSingletonVersionCheckFallback("default", "@angular/cdk/table", [1,16,1,1], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_table_mjs-_5b101").then(() => (() => (__webpack_require__(4523)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"core_app_shell_src_bootstrap_ts": [
		2611,
		3984,
		8592,
		3510,
		1064,
		8103,
		4187,
		3821,
		1320,
		7109,
		5943,
		8303,
		3656
	],
	"node_modules_angular_cdk_fesm2022_observers_mjs-_b1b10": [
		2611,
		8103,
		8303
	],
	"node_modules_angular_cdk_fesm2022_table_mjs-_5b100": [
		2611,
		4187,
		8103,
		8303
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		2611,
		4187,
		8103,
		8303
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		2611
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		8303,
		8103
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0": [
		2611,
		4187,
		8103,
		8303
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a220": [
		2611,
		3984,
		4187,
		8103,
		8303
	],
	"node_modules_ng-bootstrap_ng-bootstrap_fesm2022_ng-bootstrap_mjs-_1d630": [
		2496,
		2611,
		4187,
		8103,
		8303
	],
	"node_modules_swimlane_ngx-charts_fesm2020_swimlane-ngx-charts_mjs-_7c260": [
		2611,
		3656,
		4187,
		8103,
		8303
	],
	"node_modules_angular-svg-icon_fesm2022_angular-svg-icon_mjs-_47e31": [
		2611,
		3984,
		4187,
		8103,
		8303
	],
	"node_modules_apollo-angular_fesm2022_ngApollo_mjs-_6ad90": [
		2611,
		5943,
		8103,
		8303
	],
	"dist_common_fesm2022_common_mjs-_8d250": [
		2611,
		8303
	],
	"dist_core_fesm2022_core_mjs-_5cc91": [
		2611,
		1320,
		8303,
		8103,
		8592,
		9298,
		4187,
		7109,
		3821,
		5248,
		9002,
		3510,
		6478,
		3656,
		2496,
		4462,
		3984,
		3080,
		4463
	],
	"node_modules_ng-animate_fesm2020_ng-animate_mjs-_e1c30": [
		3656
	],
	"node_modules_ngx-chips_fesm2020_ngx-chips_mjs-_65d50": [
		2496,
		2611,
		3656,
		4187,
		8103,
		8303
	],
	"node_modules_apollo-angular_fesm2022_ngApollo_mjs-_6ad91": [
		5943
	],
	"dist_core_fesm2022_core_mjs-_5cc90": [
		9298,
		5248,
		9002,
		6478,
		2496,
		4462,
		3080,
		4463
	],
	"node_modules_ng-bootstrap_ng-bootstrap_fesm2022_ng-bootstrap_mjs-_1d631": [
		2496
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}